<template>
  <tr :style="getRowStyle(shipping)">
    <template v-for="(column, colIndex) in headers">
      <td
        v-if="!compactMode"
        :key="colIndex"
        :class="[shipping.colorClass]"
        :style="getCellStyle(column, shipping)"
      >
        <span v-if="column.name2 && column.type === 'object'">{{
          shipping[column.name2]
            ? shipping[column.name2].title
            : shipping[column.name]
              ? shipping[column.name].title
              : ""
        }}</span>
        <span v-else-if="column.type && column.type === 'object'">{{
          shipping[column.name] ? shipping[column.name].title : ""
        }}</span>
        <span
          v-else-if="
            column.type &&
              column.type === 'date' &&
              !Array.isArray(shipping[column.name]) &&
              !column.edit
          "
        >
          <v-tooltip
            v-if="column.tooltip"
            top
          >
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ getDate(shipping[column.name]) | date }}</span>
            </template>
            <span>{{ getTooltipText(shipping[column.name]) }}</span>
          </v-tooltip>
          <span v-else>{{ shipping[column.name] | date }}</span>
        </span>
        <span
          v-else-if="
            column.type &&
              column.type === 'date' &&
              Array.isArray(shipping[column.name]) &&
              !column.edit
          "
        >
          <v-tooltip
            v-if="column.tooltip"
            top
          >
            <template v-slot:activator="{ on }">
              <span v-on="on">{{
                getDate(shipping[column.name]) | dateRange
              }}</span>
            </template>
            <span>{{ getTooltipText(shipping[column.name]) }}</span>
          </v-tooltip>
          <span v-else>{{ shipping[column.name] | dateRange }}</span>
        </span>
        <span
          v-else-if="
            column.type &&
              column.type === 'date' &&
              !Array.isArray(shipping[column.name]) &&
              column.edit
          "
          class="editable-field"
        >
          <RouteItemDatePicker
            v-if="
              shipping.isFirstInRoutePhase &&
                !isRouteShippingsDialogOpen &&
                canEditFactoryClosingDate &&
                !loading
            "
            :value="shipping[column.name]"
            :item="shipping"
            :column="column.name"
            store="routePlanning"
            @input="changeDate"
          />
          <span v-else-if="loading">
            <v-progress-circular
              indeterminate
              color="primary"
              size="20"
              width="2"
              class="mt-0"
            />
          </span>
          <span
            v-else
            class="font-weight-regular"
          >{{
            shipping[column.name] | date
          }}</span>
        </span>
        <TextCell
          v-else-if="
            column.maxLength &&
              shipping[column.name] &&
              shipping[column.name].length > 20
          "
          :text="shipping[column.name]"
          :max-length="column.maxLength"
        />
        <span v-else-if="column.name === 'shipping'">
          <router-link
            :to="{
              name: 'shipping',
              params: {
                id: shipping[column.name] ? shipping[column.name].id : 0
              }
            }"
            target="_blank"
          >{{
            shipping[column.name] ? shipping[column.name].title : ""
          }}</router-link>
        </span>
        <span
          v-else-if="column.type && column.type === 'icon'"
          class="text-xs-center"
        >
          <slot name="prepend-cell" />
        </span>
        <span
          v-else-if="column.type && column.type === 'menu'"
          class="text-xs-center"
        >
          <slot name="uppend-cell" />
        </span>
        <span v-else-if="column.type === 'checkbox' && isFamiliarizedShow">
          <slot name="checkbox-cell" />
        </span>
        <span v-else>{{ shipping[column.name] }}</span>
      </td>
      <td
        v-else
        :key="colIndex"
        :class="[shipping.colorClass]"
        :style="getCellStyle(column, shipping)"
      >
        <TextCell
          v-if="
            column.type &&
              column.type === 'object' &&
              shipping[column.name] &&
              shipping[column.name].title.length > column.compactMaxLength
          "
          :text="shipping[column.name].title"
          :max-length="column.compactMaxLength"
        />
        <span v-else-if="column.type && column.type === 'object'">{{
          shipping[column.name] ? shipping[column.name].title : ""
        }}</span>
        <TextCell
          v-else-if="
            column.compact === 'string' &&
              column.compactMaxLength &&
              shipping[column.name]
          "
          :text="shipping[column.name]"
          :max-length="
            column.compactMaxLength
              ? column.compactMaxLength
              : shipping[column.name].length
          "
        />
        <span
          v-else-if="
            column.type &&
              column.type === 'date' &&
              !Array.isArray(shipping[column.name]) &&
              !column.edit
          "
        >
          <v-tooltip
            v-if="column.tooltip"
            top
          >
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ getDate(shipping[column.name]) | date }}</span>
            </template>
            <span>{{ getTooltipText(shipping[column.name]) }}</span>
          </v-tooltip>
          <span v-else>{{ shipping[column.name] | date }}</span>
        </span>
        <span
          v-else-if="
            column.type &&
              column.type === 'date' &&
              Array.isArray(shipping[column.name]) &&
              !column.edit
          "
        >
          <v-tooltip
            v-if="column.tooltip"
            top
          >
            <template v-slot:activator="{ on }">
              <span v-on="on">{{
                getDate(shipping[column.name]) | dateRange
              }}</span>
            </template>
            <span>{{ getTooltipText(shipping[column.name]) }}</span>
          </v-tooltip>
          <span v-else>{{ shipping[column.name] | dateRange }}</span>
        </span>
        <span
          v-else-if="
            column.type &&
              column.type === 'date' &&
              !Array.isArray(shipping[column.name]) &&
              column.edit
          "
          class="editable-field"
        >
          <RouteItemDatePicker
            v-if="
              shipping.isFirstInRoutePhase &&
                !isRouteShippingsDialogOpen &&
                canEditFactoryClosingDate &&
                !loading
            "
            :value="shipping[column.name]"
            :item="shipping"
            :column="column.name"
            store="routePlanning"
            @input="changeDate"
          />
          <span v-else-if="loading">
            <v-progress-circular
              indeterminate
              color="primary"
              size="20"
              width="2"
              class="mt-0"
            />
          </span>
          <span
            v-else
            class="font-weight-regular"
          >{{
            shipping[column.name] | date
          }}</span>
        </span>
        <span v-else-if="column.name === 'shipping'">
          <router-link
            :to="{
              name: 'shipping',
              params: {
                id: shipping[column.name] ? shipping[column.name].id : 0
              }
            }"
            target="_blank"
          >{{
            shipping[column.name] ? shipping[column.name].title : ""
          }}</router-link>
        </span>
        <span
          v-else-if="column.type && column.type === 'icon'"
          class="text-xs-center"
        >
          <slot name="prepend-cell" />
        </span>
        <span v-else-if="column.type === 'checkbox' && isFamiliarizedShow">
          <slot name="checkbox-cell" />
        </span>
        <span v-else>{{ shipping[column.name] }}</span>
      </td>
    </template>
  </tr>
</template>

<script>
import TextCell from "./TextCell.vue";
import RouteItemDatePicker from "../../routes/components/RouteItemDatePicker.vue";
import { changeFactoryClosingDate } from "../../../backend/routesPlanningApi.js";
import auth from "../../../auth.js";

export default {
  components: { TextCell, RouteItemDatePicker },
  props: [
    "headers",
    "shipping",
    "isFamiliarizedShow",
    "isRouteShippingsDialogOpen",
  ],
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    compactMode() {
      return this.$store.getters["routePlanning/compactMode"];
    },
    canEditFactoryClosingDate() {
      return auth.isLogist() || auth.isAdmin();
    },
    planningData() {
      return this.$store.getters["routePlanning/getPlanningData"];
    },
  },
  methods: {
    getCellStyle(column, shipping) {
      let result = "";
      if (column.minWidth) {
        result += `min-width : ${
          column.minWidth ? column.minWidth : 40
        }px; width: ${column.minWidth ? column.minWidth : 40}px; `;
      }
      if (column.regionColor || column.routeColor || column.cellColor) {
        result += `background: ${
          !shipping.isFamiliarized && this.isFamiliarizedShow
            ? "#b3d4fc"
            : column.regionColor && shipping.regionColor
              ? shipping.regionColor
              : column.routeColor && shipping.routeColor
                ? shipping.routeColor
                : shipping.districtColor && column.cellColor
                  ? shipping.districtColor
                  : "#fff"
        }`;
      }
      return result;
    },
    getRowStyle(shipping) {
      return `font-weight: ${shipping.inCar ? "bold" : "normal"}; ${
        shipping.cellBorder ? shipping.cellBorder : ""
      }; background: ${
        !shipping.isFamiliarized && this.isFamiliarizedShow ? "#b3d4fc" : "#fff"
      }`;
    },
    getDate(item) {
      if (item?.fact) {
        return item.fact;
      } else if (item?.plan && !item?.fact) {
        return item.plan;
      } else {
        return null;
      }
    },
    getTooltipText(item) {
      if (item?.fact) {
        return "Фактическая дата";
      }
      if (item?.plan && !item?.fact) {
        return "Планируемая дата";
      }
    },
    async changeDate(value) {
      this.loading = true;
      const item = this.$store.getters["routePlanning/editableRouteItem"];
      await changeFactoryClosingDate(item.phaseId, value);
      await this.$store.dispatch("routePlanning/getPlanningRoutes");
      const phases = [...this.planningData];
      phases.forEach(i => {
        if (i.phaseId === item.phaseId || i.shipping.id === item.shipping.id) {
          i.factoryClosingDate = item.factoryClosingDate;
        }
      });
      this.$store.commit("routePlanning/setPlanningData", phases);
      this.$store.commit("routePlanning/setChangedItemRow", true);
      this.loading = false;
    },
  },
};
</script>
